import script from "./RankView.vue?vue&type=script&setup=true&lang=js"
export * from "./RankView.vue?vue&type=script&setup=true&lang=js"

import "./RankView.vue?vue&type=style&index=0&id=cb51b53c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb51b53c"]])

export default __exports__